import apiCall from "../../../common/api/apiCall";

import { ensureFileId } from "../../../helpers/ensureFileId";
import { formatDate } from "../../../helpers/formatDate";

import { customISODateString, preventTimeZoneDate } from "../../../helpers/preventTimeZone";

export async function getPaymentInfoOnLoad() {
    try {
        let result = await apiCall.get("GetPaymentFormInfo");

        if (result.data === null) {
            throw Error("Trouble getting info from API");
        }

        if (result?.data?.payment_notes?.length > 0) {
            result.data.payment_notes.push({ id: "-1", note: "Custom Date Range", startDate: null, endDate: null });
        }

        return result.data;
    } catch (error) {
        throw error;
    }
}

export async function getPropertyByProvider(id) {
    try {
        let result = await apiCall.get("GetPropertyByProvider", {
            params: {
                provider_id: id,
            },
        });

        if (result.data === null) {
            throw Error("Trouble getting info from API");
        }
        return result.data;
    } catch (error) {
        throw error;
    }
}

export async function getAgreementByProperty(propertyID, providerID) {
    try {
        let result = await apiCall.get("GetAgreementByProperty", {
            params: {
                property_id: propertyID,
                provider_id: providerID,
            },
        });

        if (result.data === null) {
            throw Error("Trouble getting info from API");
        }

        return result.data;
    } catch (error) {
        throw error;
    }
}

export async function submitPayment(values) {
    try {
        let result = await apiCall.get("AddPayment", {
            ...values,
        });

        if (result === undefined || result === null || result.data === null) {
            throw Error("There was an issue submitting the form.");
        }

        return result.data;
    } catch (error) {
        throw error;
    }
}

export async function getPaymentId({ check_number, check_amount, payment_date, provider_id }) {
    try {
        let result = await apiCall.post("AddPayment", {
            check_number,
            check_amount,
            provider: provider_id,
            payment_date,
        });

        let { PaymentId } = result.data;

        return PaymentId;
    } catch (error) {
        throw error;
    }
}

export async function editPayment(data) {
    try {
        const values = structuredClone(data);

        const startDate = values.payment_period.startDate;
        const endDate = values.payment_period.endDate;

        const newStartDate = startDate instanceof Date ? customISODateString(startDate) : formatDate(startDate);
        const newEndDate = endDate instanceof Date ? customISODateString(endDate) : formatDate(endDate);

        values.payment_period = {
            ...values.payment_period,
            startDate: newStartDate,
            endDate: newEndDate,
        };

        values.transactions.forEach((t) => {
            return {
                ...t,
                paymentPeriods: t.paymentPeriods.map((p) => {
                    return {
                        ...p,
                        startDate: formatDate(p.start_date),
                        endDate: formatDate(p.end_date),
                    };
                }),
            };
        });

        const result = await apiCall.post("EditPayment", {
            ...values,
        });

        return result.data;
    } catch (error) {
        throw error;
    }
}

export async function addPayment(data) {
    try {
        const values = structuredClone(data);

        const startDate = values.payment_period.startDate;
        const endDate = values.payment_period.endDate;

        const newStartDate = startDate instanceof Date ? customISODateString(startDate) : formatDate(startDate);
        const newEndDate = endDate instanceof Date ? customISODateString(endDate) : formatDate(endDate);

        values.payment_period = {
            ...values.payment_period,
            startDate: newStartDate,
            endDate: newEndDate,
        };

        // values.transactions.forEach((t) => {
        //     const { agreements, schedules, ...rest } = t;
        //     return {
        //         ...rest,
        //         paymentPeriods: t.paymentPeriods.map((p) => ({
        //             ...p,
        //             startDate: formatDate(p.start_date),
        //             endDate: formatDate(p.end_date),
        //         })),
        //     };
        // });
        values.transactions = values.transactions.map((t) => {
            const { agreements, schedules, ...rest } = t;
            return {
                ...rest,
                paymentPeriods: t.paymentPeriods.map((p) => ({
                    ...p,
                    startDate: formatDate(p.startDate),
                    endDate: formatDate(p.endDate),
                })),
            };
        });

        const result = await apiCall.post("AddPayment", {
            ...values,
        });

        return result.data;
    } catch (error) {
        throw error;
    }
}

export async function getPayment(id) {
    try {
        const result = await apiCall.get("GetPayment", {
            params: {
                PaymentId: id,
            },
        });

        if (result.data === null) {
            throw Error("Trouble getting info from API");
        }

        return ensureFileId(result.data);
    } catch (error) {
        throw error;
    }
}

export const findNameKey = (item) => {
    let possibleOptions = ["Filename", "name", "filename", "Name"];
    let length = possibleOptions.length;
    let name;
    for (let i = 0; i < length; i++) {
        let option = possibleOptions[i];
        if (item[option] !== undefined) {
            name = option;
            break;
        }
    }

    return name;
};

export const findURLKey = (item) => {
    let possibleOptions = ["URL", "url"];
    let length = possibleOptions.length;
    let name = false;
    for (let i = 0; i < length; i++) {
        let option = possibleOptions[i];
        if (item[option] !== undefined) {
            name = option;
            break;
        }
    }

    return name;
};

export async function getPaymentForForm(id) {
    try {
        let result = await apiCall.get("GetPayment", {
            params: {
                PaymentId: id,
            },
        });

        if (result.data === null) {
            throw Error("Trouble getting info from API");
        }

        result.data.payment_period.startDate = preventTimeZoneDate(result.data.payment_period.startDate);
        result.data.payment_period.endDate = preventTimeZoneDate(result.data.payment_period.endDate);

        result.data.transactions.forEach((t) => {
            t.originalValue = t.amount;
            t.paymentPeriods.forEach((p) => {
                p.startDate = preventTimeZoneDate(p.startDate);
                p.endDate = preventTimeZoneDate(p.endDate);
            });
        });

        let { attachments } = result.data;
        if (attachments.length > 0) {
            attachments.forEach((a) => {
                if (a.note === "undefined" || a.note === undefined) {
                    a.note = "";
                }
                return a;
            });
        }

        return ensureFileId(result.data);
    } catch (error) {
        throw error;
    }
}

const ranks = {
    Monthly: 1,
    "Every Other Month": 2,
    Quarterly: 3,
    "Every 6 Months": 4,
    Annual: 5,
    "One Time Payment": 6,
};

function sortRanks(a, b) {
    return ranks[a.termName] - ranks[b.termName];
}

export async function getSchedule({ agreement = null, property = null, paymentDate = null }) {
    try {
        if (!agreement || !property || !paymentDate) {
            return {};
        }
        const result = await apiCall.get("GetPaymentSchedule", {
            params: {
                contract: agreement,
                property,
                paymentDate,
            },
        });

        if (result.data === null) {
            throw Error("Trouble getting data.");
        }
        return result.data;
        // return result.data.sort(sortRanks);
    } catch (error) {
        console.error(error);
        throw error;
    }
}

export async function getRevenueTypes(propertyId) {
    try {
        const result = await apiCall.get("GetRevenueType", {
            params: {
                property_id: propertyId,
            },
        });

        if (result.data === null) {
            throw Error("Trouble getting data.");
        }

        return result.data;
    } catch (error) {
        console.error(error);
        throw error;
    }
}

export async function addNewPaymentSchedule(data) {
    try {
        const result = await apiCall.post("AddPaymentSchedule", {
            ...data,
        });

        if (result.data === null) {
            throw Error("Trouble getting data.");
        }

        const property = result?.data?.properties[0];

        if (property) {
            result.data.propertyId = property.propertyId;
            result.data.propertyName = property.propertyName;
            result.data.previousSplit = property.previousSplit;
            result.data.currentSplit = property.currentSplit;
            result.data.splitType = property.splitType;
            result.data.fee = property.fee;
            result.data.feeType = property.feeType;
            result.data.estimatedAmount = property.estimatedAmount;
            delete result.data.properties;
        }

        return result.data;
    } catch (error) {
        console.error(error);
        throw error;
    }
}

export async function checkIfPaymentExists({ check_amount = "", provider_id = "", check_number = "" }) {
    try {
        if (!check_amount || !provider_id || !check_number) {
            return false;
        }

        let result = await apiCall.get("DoesPaymentExist", {
            params: {
                check_amount,
                provider_id,
                check_number,
            },
        });

        if (result.data === null) {
            throw Error("Trouble getting data.");
        }

        return result.data.exists;
    } catch (error) {
        console.error(error);
        throw error;
    }
}

export async function getPaymentComments(id) {
    try {
        if (!id) {
            return [];
        }

        const result = await apiCall.get("GetPaymentComments", {
            params: {
                id,
            },
        });

        if (result.data === null) {
            throw Error("Trouble getting data.");
        }

        const format = result.data.map((c) => {
            c.date = new Date(c.date);
            c.reminderDate = preventTimeZoneDate(c.reminderDate);
            return c;
        });

        return format;
    } catch (error) {
        console.error(error);
        throw error;
    }
}

export async function addOverride(data = []) {
    try {
        if (data.length === 0) {
            return [];
        }

        const result = await apiCall.post("AddOverride", data);
        return result.data;
    } catch (error) {
        console.error(error);
        throw error;
    }
}
